import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { IPantallaCustomizableRequest, IPantallaCustomizableResponse } from '../interfaces/pantalla-customizable.interface';

export interface IOpcionVariable {
  sOpcion: string;
  sValor: string;
}

export interface IOpcionVariableRequest {
  sTabla: string;
  sCampo: string;
  iIdioma: number;
}

export interface IOpcionVariableResponse {
  success: boolean;
  data: IOpcionVariable[];
}

export interface IPantallaCustomizableSaveRequest {
  sUsuario: string;
  iAccion: number;
  sClave: string;
  sDescrip: string;
  sTipoPant: string;
  iNumReg: number;
}

export interface IPantallaCustomizableSaveResponse {
  success: boolean;
  data: {
    error: string;
  }[];
}

export interface ICampoCustomizableRequest {
  iAccion: number;
  sCampo: string;
  sCaract: string;
  iNumReg: number;
}

export interface ICampoCustomizableResponse {
  success: boolean;
  data: {
    descripcion: string;
    caracteristica: string;
    itipo: number;
  }[];
}

export interface INuevoCampoSaveRequest {
  iAccion: number;
  sClave: string;
  iOrden: number;
  sCampo: string;
  sEtiqueta: string;
  iObliga: number;
}

export interface INuevoCampoSaveResponse {
  success: boolean;
  data: {
    error: string;
  }[];
}

export interface ICamposTablaRequest {
  sClave: string;
  iOrden: number;
  sCampo: string;
  sEtiqueta: string;
  iObliga: number;
}

export interface ICamposTablaResponse {
  success: boolean;
  data: {
    pagina: string;
    campo: string;
    etiqueta: string;
    obliga: number;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class PantallasCustomizablesService {

  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) { }

  getPantallasCustomizables(request: IPantallaCustomizableRequest): Observable<IPantallaCustomizableResponse> {
    return this.http.post<IPantallaCustomizableResponse>(`${this.apiUrl}Solicitudes/Getpantvar4`, request);
  }

  getOpcionesTipo(): Observable<IOpcionVariableResponse> {
    const request: IOpcionVariableRequest = {
      sTabla: "reporte",
      sCampo: "tipo",
      iIdioma: 0
    };
    return this.http.post<IOpcionVariableResponse>(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, request);
  }

  savePantallaCustomizable(request: IPantallaCustomizableSaveRequest): Observable<IPantallaCustomizableSaveResponse> {
    return this.http.post<IPantallaCustomizableSaveResponse>(`${this.apiUrl}GetMnto/GetPantvarerr`, request);
  }

  getCamposCustomizables(request: ICampoCustomizableRequest): Observable<ICampoCustomizableResponse> {
    return this.http.post<ICampoCustomizableResponse>(`${this.apiUrl}Customizable/NvoscampList`, request);
  }

  saveNuevoCampo(request: INuevoCampoSaveRequest): Observable<INuevoCampoSaveResponse> {
    return this.http.post<INuevoCampoSaveResponse>(`${this.apiUrl}GetMnto/Getdetpantvarerr`, request);
  }

  getCamposTabla(request: ICamposTablaRequest): Observable<ICamposTablaResponse> {
    return this.http.post<ICamposTablaResponse>(`${this.apiUrl}GetMnto/GetdetpantvarLst`, request);
  }
} 